var map = {
	"./ar": 141,
	"./ar.js": 141,
	"./de": 142,
	"./de.js": 142,
	"./es": 143,
	"./es.js": 143,
	"./fr": 144,
	"./fr.js": 144,
	"./hi": 145,
	"./hi.js": 145,
	"./it": 146,
	"./it.js": 146,
	"./ja": 147,
	"./ja.js": 147,
	"./ko": 148,
	"./ko.js": 148,
	"./pt": 149,
	"./pt.js": 149,
	"./ru": 150,
	"./ru.js": 150,
	"./zh-cn": 151,
	"./zh-cn.js": 151,
	"./zh-hk": 152,
	"./zh-hk.js": 152,
	"./zh-tw": 153,
	"./zh-tw.js": 153
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 313;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@alife/next/lib/_components/@alife/next-moment/lib/locale ^\.\/.*$
// module id = 313
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11